import { render, staticRenderFns } from "./ViewMembersHeader.vue?vue&type=template&id=198de64f&scoped=true"
import script from "./ViewMembersHeader.vue?vue&type=script&lang=js"
export * from "./ViewMembersHeader.vue?vue&type=script&lang=js"
import style0 from "./ViewMembersHeader.vue?vue&type=style&index=0&id=198de64f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198de64f",
  null
  
)

export default component.exports